/**
 * 角色显示名称映射
 */
export const ROLE_LABELS = {
    director: '主管',
    finance: '财务',
    hr: '人事',
    admin: '行政',
    ops: '运维',
    pm: '项目经理',
    developer: '开发人员',
};
/**
 * 组类型显示名称映射
 */
export const GROUP_LABELS = {
    product: '产品组',
    design: '美术组',
    frontend: '前端组',
    backend: '后端组',
    testing: '测试组',
};
/**
 * 所有公司角色列表
 */
export const COMPANY_ROLES = [
    'director',
    'finance',
    'hr',
    'admin',
    'ops',
    'pm',
    'developer',
];
/**
 * 所有组类型列表
 */
export const GROUP_TYPES = ['product', 'design', 'frontend', 'backend', 'testing'];
//# sourceMappingURL=roles.js.map